import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import pallet from '../../../layouts/pallet';
import { OutStandingFeeReportProps } from '../types/outstandingFeeReportType';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { dataGridSx } from '../../common/styled/DataGrid';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const OutStandingFeeReportTable = ({
  outStandingReportData
}: {
  outStandingReportData: OutStandingFeeReportProps[];
}) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(outStandingReportData);

  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);

  const columnsToDisplay: GridColDef[] =
    tableColumnUtils.getColumnsToDisplay(dynamicColumns);

  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={outStandingReportData}
        columns={columnsToDisplay}
        getRowId={(row) => row['Sr. No.']}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        slots={{
          toolbar: CustomDataGridToolbar,
          noRowsOverlay: () => (
            <Typography sx={{ p: 2 }}>No data to show</Typography>
          )
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default OutStandingFeeReportTable;
